import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { useAuth } from "../context/AuthContext";
import "./Login.css";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const token = searchParams.get("t") || "";

  const [status, setStatus] = useState(token ? "working" : "error");
  const [message, setMessage] = useState(
    token ? "Verifying your email…" : "This verification link is missing a token.",
  );

  useEffect(() => {
    if (!token) return;

    let cancelled = false;
    (async () => {
      try {
        const res = await fetch("/api/verify-email", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ token }),
        });
        const data = await res.json().catch(() => ({}));
        if (cancelled) return;
        if (!res.ok) {
          setStatus("error");
          setMessage(data.error || data.detail || "Verification failed.");
          return;
        }
        setStatus("ok");
        setMessage("Your email is verified. Signing you in…");
        await refreshUser();
        navigate("/dashboard", { replace: true });
      } catch {
        if (!cancelled) {
          setStatus("error");
          setMessage("Could not reach the server. Try again shortly.");
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [token, navigate, refreshUser]);

  return (
    <div className="login-shell">
      <div className="login-shell__bg" aria-hidden="true">
        <div className="login-shell__blob login-shell__blob--tr" />
        <div className="login-shell__blob login-shell__blob--bl" />
      </div>
      <div className="login-shell__grid" style={{ maxWidth: "480px", margin: "0 auto" }}>
        <section className="login-card">
          <div className="login-card__header">
            <h2 className="login-card__title">
              {status === "ok" ? "Verified" : status === "error" ? "Verification" : "Verifying"}
            </h2>
            <p className="login-card__hint">{message}</p>
          </div>
          {status === "error" && (
            <p className="login-card__signup">
              <Link to="/login">Back to sign in</Link> ·{" "}
              <Link to="/signup">Sign up</Link>
            </p>
          )}
        </section>
      </div>
    </div>
  );
}
